/* eslint-disable no-unused-vars */
import {
  mapActions, mapGetters,
} from 'vuex';

import isServer from '@/utils/isServer';

if (!isServer) {
  var { VuetablePagination } = require('vuetable-2');
}

export default {
  name: 'GroupFollowersAdmin',
  components: {
    VuetablePagination,
  },
  // props: ['tableFields', 'tableData'],
  props: ['tableData', 'groupName'],
  data: () => ({
    tableFields: [
      {
        name: '__slot:participant',
        title: 'Deelnemer',
        // visible: false,
      },
      {
        name: '__slot:joinDate',
        title: 'Volgdatum',
      },
      {
        name: '__slot:birthDate',
        title: 'Geboortedatum',
      },
      {
        name: 'email',
        title: 'Email',
      },
      {
        name: '__slot:isAdmin',
        title: 'Admin',
      },
      {
        name: '__slot:actions',
        title: 'Actie',
        // visible: false,
      },
    ],
  }),
  computed: {
    ...mapGetters('group', {
      group: 'getGroup',
    }),
  },
  methods: {
    ...mapActions('group', {
      addAdmin: 'ADD_GROUP_ADMIN',
      removeAdmin: 'REMOVE_GROUP_ADMIN',
      removeGroupFollower: 'REMOVE_GROUP_FOLLOWER',
    }),
    onDataManager() {
      return this.tableData;
    },
    disabledToggle(data) {
      if ((this.tableData.filter((t) => t.isAdmin).length < 2) && data.isAdmin) {
        return true;
      }
      return false;
    },
    adminStateChanged(event, rowData) {
      const paramsObj = {
        groupId: this.group.id,
        userId: rowData.id,
      };

      if (event.target.checked) {
        this.addAdmin(paramsObj).then(() => {
          this.$emit('refreshFollowers');
          this.$toasted.show(`${rowData.firstname} ${rowData.lastname} is nu admin van ${this.groupName}.`, { type: 'success' });
        }).catch((error) => {
          this.$toasted.show(...error.response.data);
        });
      } else {
        this.removeAdmin(paramsObj).then(() => {
          this.$emit('refreshFollowers');
          this.$toasted.show(`${rowData.firstname} ${rowData.lastname} is niet langer admin van ${this.groupName}.`, { type: 'success' });
        }).catch((error) => {
          this.$toasted.show(...error.response.data);
        });
      }
    },
    removeFollowerEvent(event, rowData) {
      const paramsObj = {
        groupId: this.group.id,
        followerId: rowData.id,
      };

      this.removeGroupFollower(paramsObj).then(() => {
        this.$emit('refreshFollowers');
        this.$toasted.show(`${rowData.firstname} ${rowData.lastname} is verwijderd als volger.`, { type: 'success' });
      }).catch((error) => {
        this.$toasted.show(...error.response.data);
      });
    },
  },
  watch: {
    tableData() {
      this.$refs.vuetable.refresh();
    },
  },
};
